module.exports = __webpack_public_path__ + "img/function_2_param_1_result.cbc4e261.png";